var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [
        _vm._v(" Migration #" + _vm._s(_vm.migration.id) + " ")
      ]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "3"
                  }
                },
                [_c("div", [_vm._v(_vm._s(_vm.migration.service_name))])]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "3"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.migration.event_title) + " ")]
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-capitalize text-center",
                  attrs: {
                    cols: "12",
                    sm: "3"
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mb-1",
                      attrs: {
                        small: "",
                        color: _vm.migration.status_color
                      }
                    },
                    [_vm._v(" mdi-circle ")]
                  ),
                  _vm._v(" " + _vm._s(_vm.migration.status) + " ")
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "3"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        to: {
                          name: "migration_details",
                          params: {
                            id: _vm.migration.id
                          }
                        }
                      }
                    },
                    [_vm._v("View Details")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.hasSubaccounts
            ? [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "font-weight-bold",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [_vm._v(" Subaccounts: ")]
                    )
                  ],
                  1
                ),
                _vm._l(_vm.migration.subaccounts, function(subMigration) {
                  return _c(
                    "v-row",
                    {
                      key: "subM-".concat(subMigration.id)
                    },
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            sm: "3"
                          }
                        },
                        [
                          _c("div", [
                            _vm._v(_vm._s(subMigration.resold_username))
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            sm: "3"
                          }
                        },
                        [_vm._v(" " + _vm._s(subMigration.completed_at) + " ")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "text-capitalize text-center",
                          attrs: {
                            cols: "12",
                            sm: "3"
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mb-1",
                              attrs: {
                                small: "",
                                color: _vm.migrationStatusColor(
                                  subMigration.status
                                )
                              }
                            },
                            [_vm._v(" mdi-circle ")]
                          ),
                          _vm._v(" " + _vm._s(subMigration.status) + " ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }